import React,{ useState } from 'react';
import Nav from "../src/pages/Nav"
import Top from "../src/pages/Top"
import Courses from "../src/pages/Courses"
import Introduce from "../src/pages/Introduce"
import Teachers from "../src/pages/Teachers"
import Records from "../src/pages/Records"
import Footer from "../src/pages/Footer"
import {
   BrowserRouter as Router,
   Switch,
   Route
} 
from "react-router-dom"
import pw from "./login/password"
import { auth } from "./config/firebase"
import ResetCSS from "./ResetCSS"
import LibCSS from "./libCSS"

const App = () => {

   const [school, setSchool] = useState("hs")

   auth.signInWithEmailAndPassword("tenshinjuku1@gmail.com", pw)
      .then(res => {
      })
      .catch(err => {
         console.log(err);
      })

   return (
      <Router>
         <ResetCSS/>
         <LibCSS/>
         <Nav />
         <Switch>
            <Route path="/" exact>
               <Top
                  setSchool={setSchool}
               />
            </Route>
            <Route path="/courses">
               <Courses 
                  school={school}
                  setSchool={setSchool}
               />
            </Route>
            <Route path="/teachers">
               <Teachers />
            </Route>
            <Route path="/introduce">
               <Introduce />
            </Route>
            <Route path="/records">
               <Records />
            </Route>
         </Switch>
         <Footer />
      </Router>
   )
}

export default App;
